import API from "../axiosConfig";

export const getSubscriptionTypes = async () => {
  try {
    const response = await API.get("/subscription-types");
    return response.data.data || []; // Ensure we return an empty array if no data is found
  } catch (error) {
    console.error("Error fetching subscription types:", error);
    throw error;
  }
};

export const createSubscriptionType = async (subscriptionTypeData) => {
  try {
    const response = await API.post(
      "/subscription-types",
      subscriptionTypeData
    );
    return response.data;
  } catch (error) {
    console.error("Error creating subscription type:", error);
    throw error;
  }
};

export const updateSubscriptionType = async (
  subscriptionTypeId,
  subscriptionTypeData
) => {
  try {
    const response = await API.put(
      `/subscription-types/${subscriptionTypeId}`,
      subscriptionTypeData
    );
    return response.data;
  } catch (error) {
    console.error("Error updating subscription type:", error);
    throw error;
  }
};

// subscription-types/{id}/location-types

export const getAvailableLocationTypes = async (subscriptionTypeId) => {
  try {
    const response = await API.get(
      `subscription-types/${subscriptionTypeId}/location-types`
    );
    return response.data.data || []; // Ensure we return an empty array if no data is found
  } catch (error) {
    console.error("Error fetching available location types:", error);
    throw error;
  }
};
